import { IncidentId } from '@collector/sportsapi-client-legacy'
import { EventRelatedStatusValue } from '@desktop/views/Relation/Sports/configuration'

export function isObjectValue(
  value: EventRelatedStatusValue,
): value is Exclude<EventRelatedStatusValue, IncidentId> {
  return typeof value === 'object'
}

export function getIncidentId(value: EventRelatedStatusValue): IncidentId {
  return isObjectValue(value) ? value.incidentId : value
}
